var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MethodButtonBase',{class:_vm.$style.base,scopedSlots:_vm._u([{key:"slot1",fn:function(){return [_c('IconMojeId',{class:_vm.$style.icon})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }